import { useMutation, useQuery } from '@tanstack/react-query';
import { createServiceRequestApi, getServiceRequestsApi, approveGuestRequestApi } from '../api/serviceRequest';
import { useToast } from '../context/ToastContext';

export const useServiceRequests = () =>
  useQuery({ queryKey: ['service-requests'], queryFn: () => getServiceRequestsApi({ page: 1, limit: 100 }) });

export const useCreateServiceRequest = () =>
  useMutation({ mutationFn: createServiceRequestApi });

export const useApproveGuestRequest = () => {
  const { error, success } = useToast();
  return useMutation({
    mutationFn: approveGuestRequestApi,
    onSuccess: () => success('Request approved.'),
    onError:   (e) => error(e?.message || 'Failed to approve request.'),
  });
};
